import { TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

export function ClientSettingNetworkErrorModal({
  isOpen,
  closeModal,
  titleText,
}: {
  isOpen: boolean;
  closeModal: () => void;
  titleText: string;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      titleContent={<span className="text-xl font-semibold">{titleText}</span>}
    >
      <div className="flex flex-col justify-between items-start h-[100px]">
        <div className="flex flex-col justify-start items-start gap-2">
          <span className="text-xs text-mars">Please try again later</span>
        </div>
        <div className="flex justify-end w-full">
          <TertiaryButton onClick={closeModal}>CLOSE</TertiaryButton>
        </div>
      </div>
    </Modal>
  );
}
